<template>
  <div>
    <vue-bootstrap-typeahead
      class="mb-4"
      :data="listEmpresa"
      v-model="queryEmpresa"
      size="sm"
      :serializer="r => showEmpresa(r)"
      :placeholder="'Digite a empresa para gerenciar'"
      @hit="selectEmpresa"
    >
      <template slot="append">
        <i class="fa fa-close"></i>
      </template>
    </vue-bootstrap-typeahead>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  computed: {
    user() {
      return this.$store.getters.user;
    },
    menuCredenciado() {
      return this.menuCredenciadoAgendamento;
    },
    empresa() {
      return this.$store.getters.empresa || {};
    },
    imgEmpresa() {
      return `${axios.defaults.baseURL}/api/juridica/${this.empresa._id}/img`;
    },
    isAdministrador() {
      return this.$store.getters.isAdministrador;
    },
    isVendedorMaster() {
      return this.$store.getters.isVendedorMaster;
    },
    isVendedor() {
      return this.$store.getters.isVendedor;
    }
  },
  watch: {
    queryEmpresa(newQuery) {
        this.getEmpresa(newQuery)
    }
  },
  data() {
    return {
      listEmpresa: [],
      queryEmpresa: "",
      empresaSelected: null
    };
  },
  methods: {
    selectEmpresa(empresa) {
      // eslint-disable-next-line
      console.log('Empresa SELECTED', empresa);
      this.$store.dispatch("setEmpresa", empresa);
    },
    showEmpresa(empresa) {
      return empresa.name || '';
    },
    async getEmpresa(query) {
      if (!query) query = '';
      const response = await axios.get(
        "/api/juridica?name__regex=/.*" + query + ".*/i"
      );
      this.listEmpresa = response.data;
    }
  }
};
</script>
<style scoped>
.list-group-item.active {
    color: black !important;
    font-weight: bold !important;
}
</style>